(function (app, ng) {

    app.component("editStockQuestion",
        {
            controller: editStockQuestionController,
            templateUrl: "/App/Dashboard/ManageStockQuestions/ConfigureStockQuestions/EditStockQuestion/template.html",
            bindings: {
                question: "<",
                onSave: "&",
                firelightQuestion: "<",
                rightBridgeQuestion: "<"
            }
        });

    editStockQuestionController.$inject = ["$state", "$mdDialog", "stockQuestionApi"];

    function editStockQuestionController($state, $mdDialog, stockQuestionApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                save: save,
                close: close,
                UI: {}
            });

        this.$onInit = function () {
            $ctrl.onSave({
                $func: function () {
                    return save();
                }
            });
        }

        function close() {
            $ctrl.UI.isClosing = true;
            $mdDialog.hide().then(function () { $ctrl.UI.isClosing = false; });
        }

        function save() {
            if ($ctrl.question.QuestionText.length && $ctrl.question.Type) {
                $ctrl.UI.isSaving = true;
                if ($ctrl.question.Type === "LongText" || $ctrl.question.Type === "ShortText")
                    $ctrl.PossibleAnswers = null;
                return stockQuestionApi.updateStockQuestion($ctrl.question).then(function () {
                    //close();
                });
            }
        }
    }
})(window.app, window.angular); //jshint ignore:line